import { observable } from 'mobx';

import { LaboratoryServiceLongList } from '@lab/store/LaboratoryServiceLongList';

export class LaboratoryServicePageStore {
    public static Name = 'laboratoryServicePageStore' as const;

    @observable public laboratoryServiceList = new LaboratoryServiceLongList();
}

export const laboratoryServicePageStore = new LaboratoryServicePageStore();
